import React, {useContext, useEffect, useState} from 'react'
import {general as textsGeneral} from '../../../translate/Translate.jsx'
import {ItemBagContext} from '../../../context/ItemBagContext.jsx'

import {TextField} from '@mui/material'
import './inputObservation.scss'

const InputObservation = ({visible}) => {
    const {setObservationItem, isEdit, item} = useContext(ItemBagContext)
    const [input, setInput] = useState('')
    const handleChance = (e) => {
        setObservationItem(e.target.value)
        setInput(e.target.value)
    }
    const checkObservation = () => {
        if (isEdit) {
            setObservationItem(item.observation)
            setInput(item.observation)
        }
    }
    useEffect(() => checkObservation(), [isEdit])
    return <div className={'input-observation'}>
        {(visible) && <TextField
            value={input}
            focused={true}
            fullWidth={true}
            color={'secondary'}
            label={textsGeneral.observation}
            placeholder={textsGeneral.observation}
            onChange={handleChance}/>}
    </div>
}

export default InputObservation
